import React from 'react';

import {
  Box,
  Grid,
  Card,
  Typography,
} from '@mui/material';

import { Route, Routes } from 'react-router-dom';

import useFormWizardNav from './useFormWizardNav';

import FormWizardActions from './FormWizardActions';

export type FormPaths = {
  path: string;
  element: React.ReactElement;
  label: string;
  hidden?: boolean;
}

export type FormWizardProps = {
  edit: boolean;
  formPaths: FormPaths[];
}

const FormWizard = ({ edit, formPaths }: FormWizardProps) => {
  const {
    currentPath,
    next,
    previous,
    isFirstPage,
    isLastPage,
  } = useFormWizardNav(formPaths);

  return (
    <Grid container>
      <Grid size={12}>
        <Card variant="outlined">
          <Grid container spacing={6} padding="2%" display="flex" justifyContent="center">
            <Grid
              size={{
                xs: 12,
                md: 12,
                lg: 7,
                xl: 5,
              }}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  <Typography fontWeight="bold" align="center" color="primary" variant="h6">{currentPath.label}</Typography>
                </Grid>
                <Grid size={12}>
                  <Routes>
                    {formPaths.map((formPath) => (
                      <Route
                        key={formPath.path}
                        path={formPath.path}
                        element={<Box>{formPath.element}</Box>}
                      />
                    ))}
                  </Routes>
                </Grid>
                <Grid
                  display="flex"
                  justifyContent="end"
                  size={12}
                >
                  <FormWizardActions
                    next={next}
                    isLastPage={isLastPage}
                    previous={previous}
                    isFirstPage={isFirstPage}
                    edit={edit}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default FormWizard;
